
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { myIsNaN } from "@common/src/utils/verify";
import TestIconSelect from "@common/src/components/scope/test-icon-select/index.vue";
import t from "@common/src/i18n/t";
const testingItem = namespace("testing-item");
const app = namespace("app");
const base = namespace("base");
const serviceItem = namespace("service-item");

@Component({
  components: { TestIconSelect }
})
export default class TestItemEdit extends Vue {
  @testingItem.Action saveTestItems;
  @testingItem.Action getTestItemsDetail;
  @base.Action getDictionaryList;
  @base.State temporarilyItemCode;
  @base.Mutation setTemporarilyItemCode;
  @serviceItem.Action getServiceItemList;
  @app.Mutation setPBPX;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;

  get breadData() {
    return [
      { name: this.$t("test.test-item"), path: "/setting/test-items" },
      { name: this.isAdd ? t("setting.add-test-items") : t("setting.edit-test-items") }
    ];
  }
  get isAdd() {
    return this.$route.name === "settingTestItemsAdd";
  }
  mainInfoRules: any = {
    checkItemName: [
      {
        required: true,
        message: t("setting.enter-test-item-name"),
        trigger: "blur"
      }
    ]
  };
  showSettingValue: boolean = false; // 是否显示设置检测值弹窗
  mainInfoFormData: any = {
    checkItemName: "",
    checkItemNo: "",
    iconUrl: "",
    recommendServiceArray: [],
    status: "1"
  };
  currentSettingRowData: any = {};

  get currentSettingRowIdx() {
    return this.currentSettingRowData["idx"] || 0;
  }
  get testItemCode() {
    return this.$route.params.id;
  }
  definitionNewTestItem: any = {
    subItemName: "",
    subItemClassName: "",
    remark: "",
    valueType: "2", // 2:选项 1:数值
    valueOptions: [],
    complete: false // 是否输入完成
  };
  definitionSettingRow: any = {
    maxValue: "",
    minValue: "",
    remark: "",
    txtValue: "",
    warningLevel: "",
    minValueOperator: "gt",
    maxValueOperator: "le"
  };
  created() {
    this.setPBPX(52);
    this.init();
    this.loadTempItemData();
  }
  init() {
    this.handleSearchServiceItemList();
    this.getDictionaryList("check_warning_level").then(data => {
      this.propertyList = data;
    });
    if (!this.isAdd) {
      this.loadTempItemData(this.testItemCode);
    }
  }
  loadTempItemData(code?) {
    if (!this.temporarilyItemCode && !code) return;
    this.getTestItemsDetail({
      checkItemCode: code || this.temporarilyItemCode
    }).then(data => {
      if (data.data) {
        data.data.recommendServiceArray &&
          data.data.recommendServiceArray.forEach(serviceItem => {
            if (
              !this.serviceItemList.some(item => {
                return serviceItem.serviceCode === item.serviceCode;
              })
            ) {
              this.serviceItemList.push({
                serviceCode: serviceItem.serviceCode,
                serviceName: serviceItem.serviceName
              });
            }
          });
        data.data.recommendServiceArray = data.data.recommendServiceArray
          ? data.data.recommendServiceArray.map(item => item.serviceCode)
          : [];
        Object.assign(this.mainInfoFormData, data.data);
        this.newTestItemList = data.data.subItems.map(item => {
          item.complete = true;
          return item;
        });
      }
    });
  }
  createProperty(prop) {
    return Object.assign({}, this.definitionSettingRow, {
      warningLevel: prop
    });
  }
  newTestItemList: any = [];
  propertyList: any = [];
  handleSettingItemValue(row, index) {
    if (this.newTestItemList[index].valueOptions.length === 0) {
      this.newTestItemList[index].valueOptions = [this.createProperty("3"), this.createProperty("1")];
    }
    this.currentSettingRowData = Object.assign({}, row, { idx: index });
    this.showSettingValue = true;
  }
  handleDeleteRow(index) {
    this.newTestItemList.splice(index, 1);
    this.saveItems("1");
  }
  handleSetingEnd(showError = true) {
    // 因为这里 valueOptions 属于二级对象，所有这里浅拷贝可以直接判断
    let dataInvalid = false;
    let unInputFull = false;
    let normalCount = 0;
    let currentRowValueList = this.currentSettingRowData.valueOptions;
    if (currentRowValueList.length < 2) {
      showError && this.$message.error(t("setting.two-column-test-values"));
      return;
    }
    currentRowValueList.forEach(item => {
      if (item.warningLevel === "3") {
        normalCount++;
      }
      if (this.currentSettingRowData.valueType === "1") {
        if (myIsNaN(item.minValue) || myIsNaN(item.maxValue)) {
          dataInvalid = true;
        }
        unInputFull = !item.minValue || !item.maxValue;
      } else {
        unInputFull = !item.txtValue;
      }
    });
    if (normalCount < 1) {
      showError && this.$message.error(t("setting.column-normal-test"));
      return;
    }

    if (normalCount > 1) {
      showError && this.$message.error(t("setting.only-one-column"));
      return;
    }

    if (unInputFull) {
      showError && this.$message.error(t("setting.enter-full-option-value"));
      this.newTestItemList[this.currentSettingRowIdx].complete = false;
      return;
    }

    if (dataInvalid) {
      showError && this.$message.error(t("setting.option-value-numeric-type"));
      this.newTestItemList[this.currentSettingRowIdx].complete = false;
      return;
    }
    this.showSettingValue = false;
    this.newTestItemList[this.currentSettingRowIdx].complete = true;
    if (this.isAdd) {
      // 如果是新增页面 保存临时数据
      this.saveItems("1");
    }
  }
  handleAddTestItem() {
    this.newTestItemList.push(Object.assign({}, this.definitionNewTestItem));
  }
  get currentRowPropertyList() {
    let currentRowInx = this.currentSettingRowData.idx;
    if (currentRowInx === 0 || currentRowInx) {
      return this.newTestItemList[currentRowInx].valueOptions;
    } else {
      return [];
    }
  }
  serviceItemList: any = [];
  handleSearchServiceItemList(name = "") {
    this.getServiceItemList({
      pageSize: 20,
      pageNum: 1,
      searchKey: name,
      serviceClass: "1"
    }).then(data => {
      this.serviceItemList = this.$safeValue(data, "data.list", []);
    });
  }
  handleAddProperty(row, index) {
    this.newTestItemList[this.currentSettingRowData["idx"]].valueOptions.splice(
      index + 1,
      0,
      this.createProperty(row.warningLevel)
    );
  }
  handleDeleteValueRow(index) {
    this.newTestItemList[this.currentSettingRowData["idx"]].valueOptions.splice(index, 1);
  }
  handleChangeValueType(row) {
    console.log(row);
    row.complete = false;
    row.valueOptions.forEach(item => {
      item.txtValue = item.minValue = item.maxValue = "";
    });
  }
  handleSaveItem() {
    (this.$refs.mainInfoForm as any).validate(valid => {
      if (valid && this.checkDataValid()) {
        this.saveItems("0");
      }
    });
  }
  checkDataValid() {
    if (this.newTestItemList.length < 1) {
      this.$message.error(t("setting.add-least-one-column"));
      return false;
    }
    let subItemNameIsNull = this.newTestItemList.some(item => {
      return !item.subItemName;
    });
    if (subItemNameIsNull) {
      this.$message.error(t("setting.enter-test-item"));
      return false;
    }
    let subClassIsNull = this.newTestItemList.some(item => {
      return !item.subItemClassName;
    });
    if (subClassIsNull) {
      this.$message.error(t("setting.enter-classification-name"));
      return false;
    }
    let isSetAllValue = this.newTestItemList.some(item => {
      return !item.complete;
    });
    if (isSetAllValue) {
      this.$message.error(t("setting.set-all-test-items"));
      return false;
    }
    return true;
  }
  saveItems(temporarily) {
    let params = Object.assign({}, this.mainInfoFormData, {
      subItems: this.newTestItemList,
      temporarily: temporarily,
      recommendServiceArray: this.mainInfoFormData.recommendServiceArray.map(item => ({
        serviceCode: item
      }))
    });
    this.btnStartLoading();
    this.saveTestItems(params)
      .then(data => {
        if (temporarily === "1") {
          this.setTemporarilyItemCode(data.data.checkItemCode);
          this.mainInfoFormData.checkItemCode = data.data.checkItemCode;
        } else {
          this.$message.success(t("base.save-success"));
          this.$router.push(`/setting/test-items`);
          this.setTemporarilyItemCode("");
        }
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
}
